import React from 'react';

import { TableHead as InterstateTableHead, TableRow } from '@interstate/components/SimpleTable';
import { StyledTableCell, StyledTableCellWithBorder } from './TaxCard.style';

export type SimpleTableHeadColumn = {
    heading: string;
    options?: {
        align?: string;
        width?: string;
    };
};

export type SimpleTableHeadProps = {
    columns: SimpleTableHeadColumn[];
};
export const TableHead: React.FC<SimpleTableHeadProps> = ({ columns }) => {
    return (
        <InterstateTableHead>
            <TableRow>
                {columns.map(({ heading, options }, index) => (
                    <StyledTableCellWithBorder key={`head-cell-${index}`} $width={options?.width}>
                        <StyledTableCell $textAlign={options?.align}>{heading}</StyledTableCell>
                    </StyledTableCellWithBorder>
                ))}
            </TableRow>
        </InterstateTableHead>
    );
};
export default TableHead;
